import Multiselect from 'components/v2/multi-select';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import { useGetDocuments } from 'utils/DocumentsHooks';
import { showToast } from 'stores/ToastStore';
import { sluggify } from '../../utils/localization/utils';

export default function MultiSelectDocumentType({
  shipmentId,
  filterDocumentTypes,
  setFilterDocumentTypes,
  excludedDocTypes,
  includedDocTypes,
  refetch,
  setRefetch,
}) {
  const { t } = useTranslation();
  const [types, setTypes] = useState([]);
  const showGetDocumentFilterTypeErrorToast = (err) => {
    showToast(
      t('GET_DOCUMENT_FILTER_TYPE_ERROR'),
      t('GET_DOCUMENT_FILTER_TYPE_ERROR', { error: err }),
      'error',
    );
  };

  const {
    data: documentsData,
    error: documentError,
    refetch: documentsRefetch,
    loading,
  } = useGetDocuments({
    foreignKeys: [shipmentId],
    type: includedDocTypes,
    excludeTypes: excludedDocTypes,
    options: {
      limit: 100,
      skip: 0,
      order: [{ field: 'createdAt', direction: 'desc' }],
    },
    fetchPolicy: 'network-only',
  });

  useEffect(() => {
    if (refetch) {
      documentsRefetch();
      setRefetch(false);
    }
  }, [refetch]);

  useEffect(() => {
    if (documentError) {
      showGetDocumentFilterTypeErrorToast(documentError);
    }
  }, [documentError]);

  useEffect(() => {
    if (documentsData && documentsData.documents.length > 0) {
      const uniqueTypes = [
        ...new Set(documentsData.documents.map((d) => d.type)),
      ];
      const formattedTypes = uniqueTypes.map((type) => ({
        name: t(sluggify(type)),
        slug: sluggify(type),
        value: type,
      }));
      setTypes(formattedTypes);
    }
  }, [documentsData]);

  const handleSelect = (documentTypes) => {
    setFilterDocumentTypes(documentTypes.map((d) => d.value));
  };

  return (
    <div className="mb-4">
      <label className="form-label block mb-2">
        {t('FILTER_BY_DOCUMENT_TYPE')}
      </label>
      <Multiselect
        label={titleize(t('DOCUMENT_TYPE'))}
        items={types}
        onSelect={handleSelect}
        showSearchInput={false}
        selectedItems={filterDocumentTypes}
      />
    </div>
  );
}
